import { useDispatch, useSelector } from "react-redux";

import VideoHeaderNew from "../../Shared/VideoHeaderNew";
import CampaignIndexContainer from "./CampaignIndexContainer";
import {
  downloadAllTranscript,
  fetchCampaignList,
  updateCampaignState,
  updateParams,
  updateVideoPageState,
} from "./VideoActions";

import gql from "graphql-tag";
import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import "./Components/video.scss";
import IndexHeader from "../../Shared/IndexHeader";
import TranscriptModel from "../../Shared/DownloadTranscriptModel";
import { usePrevious } from "../../Shared/CustomHooks";
import UploadVideoProcess from "../../Shared/VideosProcess/UploadVideoProcess";
import MultiPublish from "./Components/MultiPublish";
import { getVideoUploadDetails } from "../Home/home_actions";
import VideoPageHeader from "./Components/VideoPageHeader";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const GET_CAMPAIGN_FOLDERS = gql`
  query GetCampaignFolders(
    $brandId: String!
    $orderBy: OrderEnum!
    $stage: StageEnum!
  ) {
    getCampaignFolders(brandId: $brandId, orderBy: $orderBy, stage: $stage) {
      videoCount
      campaignDetail {
        _id
        bannerRenderAs
        generate_qr
        banner_url
        campaign_description
        campaign_product
        descriptionRenderAs
        end_date
        end_time
        hash_tag
        logo_url
        manufacturer {
          _id
          name
        }
        name
        ongoing
        products {
          _id
          name
        }
        rating_enabled
        reward
        reward_type
        start_date
        start_time
        termAndConditionRenderAs
        terms_and_conditions
        timezone
        video_time_limit
        clicks
      }
      videoCount
    }
  }
`;

const CampaignListPage = () => {
  const tabs = useSelector(
    (state) => state.videoPageStates.campaignsState.tabs
  );
  const tab = useSelector((state) => state.videoPageStates.campaignsState.tab);
  const campaignSortBy = useSelector(
    (state) => state.videoPageStates.campaignSortBy
  );
  const currentBrandId = useSelector(
    (state) => state.navbarStatsReducer.currentBrand._id
  );
  const [search, setSearch] = useState("");
  const [openTranscriptModel, setOpenTranscriptModel] = useState(false);
  const [uploadVideoModal, setUploadVideoModal] = useState(false);
  const [limitReachedModal, setLimitReachedModal] = useState(false);
  const [openMultiPublish, setOpenMultiPublish] = useState(false);
  const [uploadVideoDetails, setUploadVideoDetails] = useState({});

  const dispatch = useDispatch();

  const videos = useSelector((state) => state.videos);
  const videoParams = useSelector((state) => state.videoParams);
  const roles = useSelector((state) => state.navbarStatsReducer.roles);
  const count = useSelector((state) => state.videoData.count);

  const widgetVideoCount = useSelector(
    (state) => state.videoData.widgetVideoCount
  );
  const totalPages = useSelector((state) => state.videoData.totalPages);
  const loadingTranscriptPdf = useSelector(
    (state) => state.downloadTranscript.loadingTranscriptPdf
  );

  const currentBrand = useSelector((state) => state.selectedBrandReducer);
  const isCategoryPage = useSelector(
    (state) => state.videoPageStates.isCategoryPage
  );
  const isCampaignListPage = useSelector(
    (state) => state.videoPageStates.isCampaignListPage
  );
  const { brand_id } = currentBrand;
  const prevBrand = usePrevious(brand_id);

  useEffect(() => {
    if (!loadingTranscriptPdf) setOpenTranscriptModel(false);
  }, [loadingTranscriptPdf]);

  const fetchCampaignData = async () => {
    const manufacturerId = Cookies.get("bId") || brand_id;
    fetchCampaignList(manufacturerId)
      .then((response) => {
        dispatch(
          updateVideoPageState({
            campaigns: response?.campaign,
          })
        );
      })
      .catch(() => {
        console.log("error fetchCampaignList");
      });
  };

  const handleCloseTranscript = () => setOpenTranscriptModel(false);

  const verifiedCount = (
    fileType,
    downloadState = true,
    loadingTranscriptPdf = true
  ) => {
    dispatch(
      downloadAllTranscript({ downloadState, loadingTranscriptPdf, fileType })
    );
  };

  const downloadHandle = (fileType) => {
    if (count >= 50) {
      setOpenTranscriptModel(true);
      verifiedCount(fileType, false, false);
    } else {
      verifiedCount(fileType);
    }
  };

  const getBrandDetails = () => {
    getVideoUploadDetails({})
      .then((response) => {
        setUploadVideoDetails(response);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getBrandDetails();
  }, []);

  useEffect(() => {
    if (prevBrand && prevBrand !== brand_id) {
      getBrandDetails();
      setUploadVideoDetails({});
      fetchCampaignData();
    }
  }, [brand_id]);

  const handleCloseMultiPublish = () => setOpenMultiPublish(false);

  useEffect(() => {
    // This code will run when the component mounts
    return () => {
      // This code will run when the component unmounts
      dispatch(
        updateCampaignState({ breadcrumbs: [], showCampaignHeader: false })
      );
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      updateParams({
        tab: "Campaigns",
        transcriptView: false,
        is_widget: false,
        search: "",
        page: 1,
        isTrashTab: false,
        isFlaggedTab: false,
        isFavoriteTab: false,
        isCampaignTab: true,
        updateParamsOnly: true,
      })
    );
    dispatch(
      updateVideoPageState({
        isCategoryPage: false,
        isCampaignListPage: true,
      })
    );
    return () => {
      dispatch(
        updateVideoPageState({
          isCategoryPage: true,
        })
      );
    };
  }, [dispatch]);

  const StageEnum = {};
  ["ACTIVE", "PAST", "DRAFT"].forEach((key) => {
    StageEnum[key] = tab;
  });

  const OrderByEnum = {};
  ["OLD", "NEW", "MODIFIDED", "OPENED", "ALPHABETICAL"].forEach((key) => {
    OrderByEnum[key] = campaignSortBy;
  });

  const handleChangeTab = (tabName) => {
    dispatch(updateCampaignState({ tab: tabName }));
  };

  const { loading, error, data, refetch } = useQuery(GET_CAMPAIGN_FOLDERS, {
    variables: {
      brandId: currentBrandId,
      orderBy: OrderByEnum.OLD,
      stage: StageEnum.ACTIVE,
    },
  });
  useEffect(() => {
    refetch();
  }, [refetch]);
  const CampaignCards =
    data && data.getCampaignFolders
      ? data.getCampaignFolders.map((folder) => {
          return {
            campaignDetail: folder.campaignDetail,
            videoCount: folder.videoCount,
          };
        })
      : [];

  return (
    <>
      <IndexHeader
        // headerElements={headerElements}
        indexName="Videos"
        page="videos"
        tabs={["My Videos", "Competition"]}
        roles={roles}
        uploadVideoDetails={uploadVideoDetails}
        setUploadVideoModal={setUploadVideoModal}
      />
      {!isCampaignListPage && (
        <VideoPageHeader
          cardType="Video"
          search={search}
          setSearch={setSearch}
          downloadHandle={downloadHandle}
          uploadVideoDetails={uploadVideoDetails}
          setLimitReachedModal={setLimitReachedModal}
          setUploadVideoModal={setUploadVideoModal}
          setOpenMultiPublish={setOpenMultiPublish}
          tabs={["My Videos", "Competition"]}
        />
      )}
      <TranscriptModel
        open={openTranscriptModel}
        handleClose={handleCloseTranscript}
        handleDownloadReport={verifiedCount}
      />
      <UploadVideoProcess
        uploadVideoDetails={uploadVideoDetails}
        setUploadVideoModal={setUploadVideoModal}
        uploadVideoModal={uploadVideoModal}
        limitReachedModal={limitReachedModal}
        setLimitReachedModal={setLimitReachedModal}
        getBrandDetails={getBrandDetails}
      />
      <MultiPublish
        open={openMultiPublish}
        videos={videos}
        onClose={handleCloseMultiPublish}
        totalVideoCount={widgetVideoCount || 0}
        totalPages={totalPages}
        params={videoParams}
        pathname="videos"
      />
      <div style={{ padding: "0px 51px 50px 42px" }}>
        <VideoHeaderNew
          tabs={tabs}
          tab={tab}
          handleChangeTab={handleChangeTab}
          CampaignCards={CampaignCards}
          loading={loading}
        />

        <CampaignIndexContainer 
          CampaignCards={CampaignCards}
          loading={loading}
          tab={tab}
        />
      </div>
    </>
  );
};
export default CampaignListPage;
